
export const text = {
  headline: {
    fontFamily: 'calliope-mvb, serif',
    fontWeight: 400,
    fontSize: '1.5rem',
    letterSpacing: 0,
  },
  headlineSerif: {
    fontFamily: 'abril-display, serif',
    fontWeight: 700,
    fontStyle: 'normal'
  },
  subline: {
    letterSpacing: '0',
    fontWeight: 500,
    fontSize: ['2.5rem', '3.125rem'],
  },
  sectionHeader: {
    fontWeight: 400,
    fontSize: '1.5rem',
    letterSpacing: 0,
  },
  bodySansSerif: {
    fontFamily: 'ff-tisa-sans-web-pro, sans-serif',
    fontWeight: 300,
  },
  h1: {
    variant: 'text.headlineSerif',
    color: 'primary',
    fontSize: [7, null, null, null, 9],//54px 108px
    lineHeight: ['56px', null, null, null, '110px']
  },
  h2: {
    variant: 'text.headlineSerif',
    color: 'primary',
    fontSize: 6,//48px
  },
  h3: {
    variant: 'text.headlineSerif',
    color: 'primary',
    fontSize: 5,//36px
  },
  h4: {
    variant: 'text.headlineSerif',
    color: 'secondary',
    fontSize: 4,//32px
  },
  h5: {
    variant: 'text.bodySansSerif',
    color: 'secondary',
    fontSize: 3,//24px
    lineHeight: 1.5,
  },
  disclaimer: {
    fontSize: '0.75rem',
    letterSpacing: 0,
    fontFamily: 'nimbus-sans, sans-serif',
    fontWeight: '300'
  },
  link: {
    textDecoration: 'underline',
    color: 'primary'
  }
}